import { SubscriptionPlanId } from "@/features/subscription/types";

const PLAN_NAMES: Record<SubscriptionPlanId, string> = {
  [SubscriptionPlanId.Speak_Free_Trial]: "Free Trial",
  [SubscriptionPlanId.Speak_Pay_As_You_Go]: "Pay As You Go",
  [SubscriptionPlanId.Speak_Custom]: "Custom",
  [SubscriptionPlanId.Speak_Build_Custom_Plan]: "Build Custom Plan",
};

/**
 * Resolves a human-readable plan name from a raw `planId`. Unknown ids fall
 * back to a title-cased version of the id so the UI never renders a raw
 * `speak_*` enum value.
 */
export function getPlanName(planId: string | null | undefined): string {
  if (!planId) return "";

  return (
    PLAN_NAMES[planId as SubscriptionPlanId] ??
    planId
      .replace(/^speak[_\s-]/i, "")
      .replace(/[_-]+/g, " ")
      .replace(/\b\w/g, (c) => c.toUpperCase())
  );
}
